import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { GetTimezonesParams, Timezone } from "@/types/timezones"; // Updated import
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getTimezones = async (
  params?: GetTimezonesParams
): Promise<Timezone[]> => {
  try {
    const { data } = await axiosInstance.get("/v1/timezones", {
      params
    });

    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
